import React from 'react';
import { PAIN_HEADLINE, PAIN_TRANSITION, PAIN_TRANSITION_EMPHASIS, painCards } from '../data/poolContent';
export function PainSection() {
  return <section className="w-full bg-abyss-900 py-14 sm:py-20" aria-labelledby="pain-title" data-id="element-249" data-mp="38vu5g27ipv0y">
      <div className="mx-auto max-w-6xl px-5" data-id="element-250" data-mp="2v08brhqcan27">
        <h2 id="pain-title" className="text-center font-display text-[2.1rem] font-bold uppercase leading-none text-frost-50 sm:text-[3rem]" data-id="element-251" data-mp="2yyzblwm6wit0">
          {PAIN_HEADLINE}
        </h2>

        <ul className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-252" data-mp="2q044mibbn4on">
          {painCards.map(card => <li key={card.title} className="flex flex-col overflow-hidden rounded-2xl border border-abyss-600 bg-abyss-800" data-id="element-253" data-mp="2bbhd7i8f6mh2">
              <img src={card.image} alt={card.alt} className="aspect-[4/3] w-full object-cover" width={1200} height={900} loading="lazy" data-id="element-254" data-mp="228yf1bfkwy15" />
              <div className="flex flex-1 flex-col p-5" data-id="element-255" data-mp="3rl7m829pe3xl">
                <h3 className="font-display text-[1.45rem] font-bold uppercase leading-[1.05] text-frost-50" data-id="element-256" data-mp="3nm76ismivhet">
                  {card.title}
                </h3>
                <div className="mt-3 space-y-1" data-id="element-257" data-mp="5dgcyn5yx96j">
                  {card.lines.map(line => <p key={line} className="text-[14px] leading-snug text-body" data-id="element-258" data-mp="ews6q3423fr">
                      {line}
                    </p>)}
                </div>
              </div>
            </li>)}
        </ul>

        <div className="mx-auto mt-12 max-w-2xl text-center" data-id="element-259" data-mp="3imm6sfzj3511">
          <p className="text-[15px] leading-relaxed text-frost-100 sm:text-[17px]" data-id="element-260" data-mp="3io5ped8nps5z">
            {PAIN_TRANSITION}
          </p>
          <p className="mt-2 font-display text-[1.8rem] font-bold uppercase text-aqua sm:text-[2.2rem]" data-id="element-261" data-mp="2q5i5h15ecj6h">
            {PAIN_TRANSITION_EMPHASIS}
          </p>
        </div>
      </div>
    </section>;
}